<template>
  <div class="order-confirm">
    <div class="page-title">{{ isEdit ? '编辑地址' : '新增地址' }}</div>
    <div class="my-form">
      <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="80px">
        <el-form-item label="姓名" prop="consignee">
          <el-input v-model="form.consignee" maxlength="30" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="telephone">
          <el-input v-model="form.telephone" maxlength="11" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="地区" prop="area">
          <el-cascader ref="cascader" clearable v-model="form.area" :options="options" :props="{ value: 'code', label: 'name' }" placeholder="请选择地区"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="detailAddress">
          <el-input v-model="form.detailAddress" maxlength="50" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item label="邮政编码" prop="postcode">
          <el-input v-model="form.postcode" maxlength="10" placeholder="请输入邮政编码"></el-input>
        </el-form-item>
        <div class="def-address">
          <div class="label">设为默认收货地址</div>
          <el-switch v-model="form.defAddress" inactive-color="#a7a7a9" :inactive-value="0" :active-value="1"></el-switch>
        </div>
        <div>
          <el-button type="primary" style="width:100%;margin-top:20px;" @click="confirm">确认</el-button>
        </div>
        <div>
          <el-button v-if="isEdit" type="danger" style="width:100%;margin-top:20px;" @click="deleteAddress">删除</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import API from '../lib/API'
export default {
  name: 'OrderList',
  data() {
    let checkPhone = (rule, value, callback) => {
      if (!/^1\d{10}$/.test(value)) {
        return callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    return {
      options: [],
      isEdit: false,
      id: '',
      confirmLoading: false,
      form: {
        consignee: '',
        telephone: '',
        area: [],
        detailAddress: '',
        postcode: '',
        defAddress: 0
      },
      rules: {
        consignee: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        telephone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, {validator: checkPhone, trigger: 'blur'}],
        area: [{ required: true, message: '请选择地区', trigger: 'blur' }],
        detailAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }]
      }
    }
  },
  computed: {
    categoryDisabled() {
      if (this.dataType === '1' || (this.dataType === '2' && this.shopId)) {
        return false
      }
      return true
    }
  },
  methods: {
    confirm() {
      if (this.confirmLoading) return
      this.confirmLoading = true
      this.$refs.form
        .validate()
        .then(res => {
          let url = this.isEdit ? '/address/updateAddress' : '/address/addAddress'
          let areaNameArr = this.$refs.cascader.getCheckedNodes()[0].pathNodes
          let areaCodeArr = this.form.area
          let params = {
            ...this.form,
            provinceCode: areaCodeArr[0],
            provinceName: areaNameArr[0].label,
            cityCode: areaCodeArr[1],
            cityName: areaNameArr[1].label,
            areaCode: areaCodeArr[2],
            areaName: areaNameArr[2].label,
            userId: 2
          }
          if (this.isEdit) {
            params.id = this.id
          }
          new API(this).POST({
            url,
            params,
            cb: res => {
              this.$notify({
                title: this.id ? '修改地址成功' : '新增地址成功',
                type: 'success',
                duration: 2000
              });
              this.$router.back()
            },
            errCb: err => {
              this.confirmLoading = false
            }
          })
        })
    },
    deleteAddress() {
      new API(this).POST({
        url: '/address/deleteAddress',
        params: {id: this.id},
        cb: res => {
          this.$notify({
            title: '删除地址成功',
            type: 'success',
            duration: 2000
          });
          this.$router.back()
        }
      })
    },
    getAddressDetail() {
      new API(this).POST({
        url: `/address/getAddressDetail?id=${this.id}`,
        cb: res => {
          this.form = Object.assign({}, res)
          this.form.area = [res.provinceCode, res.cityCode, res.areaCode]
        }
      })
    }
  },
  created() {
    new API(this).POST({
      url: '/pca/findPcaList',
      cb: res => {
        this.options = res
      }
    })
    this.id = this.$route.query.id
    this.isEdit = this.id ? true : false
    this.id && this.getAddressDetail()
  }
}
</script>
<style scoped lang="less">
.my-radio {
  transform: scale(1.4);
}
.el-cascader {
  width: 100%;
}
.def-address {
  display: flex;
  justify-content: space-between;
  color: #606266;
}
.order-confirm {
  width: 400px;
  margin: 0 auto;
  background: #f1f1f1;
  border-radius: 10px;
  padding: 10px 30px 30px;
  /deep/ .el-input {
    width: 100% !important;
  }
  .page-title {
    font-size: 16px;
    font-weight: bold;
    height: 50px;
    line-height: 50px;
    text-align: center;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AddressEdit.vue